import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import Breadcrumb from "../../Components/Breadcrumb";
import { countrySchema } from "../../Validation/Validation";
const AddCountry = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const initalvalues = {
    countryName: editData?.countryName,
    countryCode: editData?.countryCode,
    sortOrder: editData?.sortOrder || 1,
    isActive: editData?.isActive ?? false,
  };
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: initalvalues,
    validationSchema: countrySchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = editingId
          ? await axiosInstance.put(
              `/country/updateCountry/${editingId}`,
              values,
            )
          : await axiosInstance.post("/country/createCountry", values);

        if (response.status === 200) {
          toast.success(response.data.message);
          navigator("/country");
        }
      } catch (error) {
        toast.error(error.response?.data?.message);
        return error;
      } finally {
        setLoading(false);
      }
    },
  });

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Country", path: "/country" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Country
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="country-sortOrder"
                        className="col-form-label "
                      >
                        Sort Order
                      </label>
                      <input
                        type="number"
                        className="form-control  border-dark "
                        id="country-sortOrder"
                        name="sortOrder"
                        placeholder="Enter  Sort Order"
                        min={1}
                        value={values.sortOrder}
                        onChange={handleChange}
                      />
                      {touched.sortOrder && errors.sortOrder && (
                        <small className="text-danger">
                          {errors.sortOrder}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="countryName" className="col-form-label ">
                        Country Name
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="countryName"
                        name="countryName"
                        placeholder="Enter Country name"
                        value={values.countryName || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.countryName && errors.countryName && (
                        <small className="text-danger">
                          {errors.countryName}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="countryCode" className="col-form-label ">
                        Country Code
                      </label>
                      <input
                        type="text"
                        className={`form-control border-dark`}
                        id="countryCode"
                        name="countryCode"
                        placeholder="Enter Country code"
                        value={values.countryCode || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.countryCode && errors.countryCode && (
                        <small className="text-danger">
                          {errors.countryCode}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-md-6 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/country">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCountry;
